export const SALES_CHANNELS = [
  {
    name: "博客來",
    url: "https://www.books.com.tw/web/sys_puballb/books/?pubid=sonbook",
  },
  {
    name: "誠品",
    url: "https://www.eslite.com/search?keyword=崧燁文化事業有限公司",
  },
  {
    name: "金石堂",
    url: "https://www.kingstone.com.tw/bookpublish/publist/61749/",
  },
  {
    name: "三民",
    url: "https://www.sanmin.com.tw/search?pu=崧燁文化",
  },
  {
    name: "momo",
    url: "https://www.momoshop.com.tw/search/崧燁文化?brand=崧燁文化",
  },
  {
    name: "蝦皮",
    url: "https://shopee.tw/sonbook",
  },
  {
    name: "Amazon Kindle",
    url: "https://www.amazon.com/s?k=崧燁文化",
  },
  {
    name: "TAAZE 讀冊",
    url: "https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=崧燁文化事業有限公司",
  },
  {
    name: "樂天 Kobo",
    url: "https://www.kobo.com/tw/zh",
  },
  {
    name: "Pubu",
    url: "https://www.pubu.com.tw/store/4193937",
  },
  {
    name: "Google Play",
    url: "https://play.google.com/store/search?q=崧燁文化=books&hl=zh-TW",
  },
  {
    name: "OverDrive",
    url: "https://www.overdrive.com/publishers/崧燁文化",
  },
  {
    name: "MyBook",
    url: "https://mybook.mobi/mybook/zh-TW/#",
  },
  {
    name: "Hami Book",
    url: "https://www.hamibook.com.tw/Search/finish?keyword=崧燁文化",
  },
];